var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Switch } from "react-vcomponents";
import { BaseComponentPlus } from "react-vextensions";
import { store } from "Store";
import { Observer } from "vwebapp-framework";
import { SubNavBar, SubNavBarButton } from "./@Shared/SubNavBar";
import { AboutUI } from "./Home/About";
import { HomeUI2 } from "./Home/Home";
let HomeUI = class HomeUI extends BaseComponentPlus({}, {}) {
    render() {
        const currentSubpage = store.main.home.subpage;
        const page = "home";
        return (React.createElement(React.Fragment, null,
            React.createElement(SubNavBar, null,
                React.createElement(SubNavBarButton, { page: page, subpage: 'home', text: 'Home' }),
                React.createElement(SubNavBarButton, { page: page, subpage: 'about', text: 'About' })),
            React.createElement(Switch, null,
                React.createElement(HomeUI2, null),
                currentSubpage === "about" && React.createElement(AboutUI, null))));
    }
};
HomeUI = __decorate([
    Observer
], HomeUI);
export { HomeUI };
